import $ from 'jquery';
import constants from 'lib/constants';
import offerService from 'framework/services/offerService';

function getOffer(link, element) {
	return offerService.getOffer(link)
		.then((data)=> {
			if(data) {
				element.html(data);
				// show the new content
				element.show();
			}else{
				// show the default
				element.show();
			}
		},
		(jqXHR)=> {
			// show the default
			element.show();
		});
}

function updateContent() {
	$('[data-offer]').each((index, item)=> {
		var element = $(item);
		var offerUrl = element.data('offer-content');
		if(offerUrl) {
			getOffer(offerUrl, element);
		}else{
			// show the default
			element.show();
		}
	});
}

export default updateContent;

updateContent();
